import { openedModelToStatePatch } from './openedModelToStatePatch/openedModelToStatePatch'

/**
 * Reports whether an opened run is an enhancement (remesh, retexture, segment, animate)
 * rather than a plain generation, by the parser its provider model resolves to: only
 * the enhancement parsers yield an enhanced action.
 *
 * @param {Object} run - ui.openedModel
 * @returns {boolean}
 */
export function isEnhancementRun(run) {
  return openedModelToStatePatch(run).schema?.enhancedAction != null
}
